import React from "react";
import PostExamUploadQr from "../components/postExamUploadQr";

export default function PostExamUploadQrPage() {
  return <PostExamUploadQr />;
}
